import React from 'react'
import { useRouter } from 'next/router'
import { routes } from 'routes'

export type PageParams = {
    apply: boolean
    slug: string
}

type ParsedUrlQuery = ReturnType<typeof useRouter>['query']

export const parseParams = (query: ParsedUrlQuery) => {
    return {
        apply: (query['apply'] as string | undefined) === 'true',
        slug: query['slug'] as string,
    }
}

export const useParams = () => {
    const router = useRouter()
    return parseParams(router.query)
}

export const usePageRouter = () => {
    const router = useRouter()
    const params = useParams()

    const removeApplyParam = React.useCallback(() => {
        router.replace(routes.job({ slug: params.slug }), undefined, {
            shallow: true,
        })
    }, [params.slug])

    return React.useMemo(() => {
        return {
            // if user refreshes page with apply query param set to true, we don't want to show application dialog
            removeApplyParam: removeApplyParam,
        }
    }, [removeApplyParam])
}
